module.exports = __webpack_public_path__ + "static/email-aadab3348d47e254a0ef3d02d535359f.png";